export default __webpack_public_path__ + "static/media/tealtruck.bd3f7e1b.jpg";